import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/weeklyship/`;

const addWeeklyShipDate = async (data) => {
  return await axios.post(API_URL , data);
};

const addBoxNo = async (payload) => {
  return await axios.post(API_URL + 'addbox' , {payload});
};

const getWeeklyShipDate = async (formData) => {
  return await axios.post(API_URL + 'byshipdate', formData);
}

const getUnmatchItemByShipDate = async (formData) => {
  return await axios.post(API_URL + 'unmatchbyshipdate', formData);
}

const updateOrderTrackingTh = async (formData) => {
  return await axios.post(API_URL + 'trackingth', formData);
}

const matchWeeklyShipAndOrder = async (formData) => {
  return await axios.post(API_URL + 'match', formData);
}

const cancelWeeklyShipOrderMatch = async (formData) => {
  return await axios.post(API_URL + 'cancelmatch', formData);
}

const awaitUnboxWeeklyShip = async (formData) => {
  return await axios.post(API_URL + 'unbox', formData);
}

const getBoxNoFromProfile = async (formData) => {
  return await axios.post(API_URL + 'boxnobyprofile', formData);
}

const getUnmatchBoxUrl = async (formData) => {
  return await axios.post(API_URL +'boximage' ,formData);
}

// Unpack photos awaiting a boxNo (boxNo-input page, unpack mode).
const getUnmatchUnpackBoxUrl = async (formData) => {
  return await axios.post(API_URL +'unpack/boximage' ,formData);
}

// Boxes with an unpack photo, not yet matched to an order (find-the-match page).
const getUnpackUnmatched = async (formData) => {
  return await axios.post(API_URL +'unpack/unmatched' ,formData);
}

const getUnmatchBoxUrlAir = async (formData) => {
  return await axios.post(API_URL +'boximage/air' ,formData);
}

const getArrivalList = async (shipDateId) => {
  return await axios.post(API_URL +'arrivallist' ,shipDateId);
}

const getBoxNosFromOrderIds = async (formData) => {
  return await axios.post(API_URL + 'getboxnofromid', formData);
}

const uploadAirBarcodes = async (formData) => {
  // formData: FormData with fields: shipDate, shop, codes (JSON string), images[]
  return await axios.post(API_URL + 'air/upload-barcodes', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

const createWeeklyShipAir = async (payload) => {
  return await axios.post(API_URL + 'air/create', payload);
};

const updateAirWeeklyShip = async (payload) => {
  return await axios.put(API_URL + 'air/update', payload);
};

const moveAirWeeklyShip = async (payload) => {
  // payload: { weeklyShipUuid, shipDateId } — move an unmatched air box to another air round
  return await axios.post(API_URL + 'air/move', payload);
};

const deleteAirWeeklyShip = async (uuids) => {
  return await axios.post(API_URL + 'air/delete', { uuids });
};

const getWeeklyShipByShipDateId = async (shipDateId) => {
  return await axios.post(API_URL + 'byshipdateid', { shipDateId });
};

const getWeeklyShipAirDetailByShipDateId = async (shipDateId) => {
  return await axios.post(API_URL + 'air-detail/byshipdateid', { shipDateId });
};

const getWeeklyShipAirSummaryByShipDateId = async (shipDateId) => {
  return await axios.post(API_URL + 'air-summary/byshipdateid', { shipDateId });
};

const setWeeklyShipActualCostItems = async (weeklyShipId, items) => {
  return await axios.put(API_URL + 'actual-cost-items', { weeklyShipId, items });
};

const processWeeklyShipGroupByAdmin = async (payload) => {
  return await axios.post(API_URL + '/admin/process-group', payload);
}

const deActionWeeklyShip = async (weeklyShipIds) => {
  return await axios.post(API_URL + '/admin/deaction', { weeklyShipIds });
}

const getShipmentGroupSummaryByShipDateId = async (shipDateId, includeCarryOver = false) => {
  return await axios.post(API_URL + 'shipment-group-summary', { shipDateId, includeCarryOver });
}

// includeExported: "Export ซ้ำ" — also re-export ลัง that already have an iShip label.
const exportShipmentGroupToExcel = async (shipDateId, shipmentGroupIds, courier, paymentNotDoneGroupIds, includeExported = false) => {
  return await axios.post(API_URL + 'shipment-group-summary/export-excel', {
    shipDateId,
    shipmentGroupIds,
    courier,
    paymentNotDoneGroupIds,
    includeExported
  }, {
    responseType: 'blob'
  });
}

const addDelayArrival = async (shipDateId) => {
  return await axios.post(API_URL +'arrival/delay' ,{shipDateId});
}

const arrivalInform = async (arrivalId) => {
  return await axios.post(API_URL +'arrival' ,arrivalId);
}

const deleteWeeklyShipDate = async (data) => {
  return await axios.post(API_URL + 'delete', data);
}

const getCompositeJobByShipDate = async (shipDateId, shop) => {
  return await axios.get(API_URL + `composite-job/by-shipdate/${shipDateId}`, {
    params: { shop }
  });
}

const generateComposite = async (shipDateId, shop) => {
  return await axios.post(API_URL + 'generate-composite', { shipDateId, shop });
}

const downloadCompositeZip = async (shipDateId, shop) => {
  return await axios.get(API_URL + `composite-job/${shipDateId}/download`, {
    params: { shop },
    responseType: 'blob'
  });
}

const previewIshipImport = async (formData) => {
  return await axios.post(API_URL + 'iship/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
  });
};

const applyIshipImport = async (payload) => {
  return await axios.post(API_URL + 'iship/apply', payload);
};

const sendArrivalNotifications = async (data) => {
  return await axios.post(`${BACKEND_URL}/api/chatcone/arrival/notify`, data);
}

const getArrivalPreview = async (data) => {
  return await axios.post(`${BACKEND_URL}/api/chatcone/arrival/preview`, data);
}

const sendTestArrivalNotification = async (data) => {
  return await axios.post(`${BACKEND_URL}/api/chatcone/arrival/test-notify`, data);
}

const arriveAirWeeklyShip = async (payload) => {
  return await axios.post(API_URL + 'air/arrive', payload);
}

const cancelAirWeeklyShip = async (weeklyShipUuid) => {
  return await axios.post(API_URL + 'air/cancel', { weeklyShipUuid });
}

const holdAirWeeklyShip = async (payload) => {
  return await axios.post(API_URL + 'air/hold', payload);
}

const getHeldAirItems = async () => {
  return await axios.get(API_URL + 'air/held');
}

const attachImageToHeldBox = async (payload) => {
  return await axios.post(API_URL + 'air/held/attach-image', payload);
}

const promoteHeldAirItem = async (payload) => {
  return await axios.post(API_URL + 'air/promote', payload);
}

// Boxes promoted from an admin machine — label still needs printing at the warehouse.
const getLabelPendingAirItems = async () => {
  return await axios.get(API_URL + 'air/label-pending');
}

const markAirLabelPrinted = async (weeklyShipUuid) => {
  return await axios.post(API_URL + 'air/label-printed', { weeklyShipUuid });
}

const scanOutWeeklyShip = async (weeklyShipId) => {
  return await axios.post(API_URL + 'scan-out', { weeklyShipId });
}

// Packing a delivery group into ลัง (Air Flow Plan step 10)
const listCartons = async (shipmentGroupId) => axios.post(API_URL + 'carton/list', { shipmentGroupId });
const addCarton = async (shipmentGroupId) => axios.post(API_URL + 'carton/add', { shipmentGroupId });
const scanIntoCarton = async (shipmentGroupId, weeklyShipId, cartonId) =>
  axios.post(API_URL + 'carton/scan', { shipmentGroupId, weeklyShipId, cartonId: cartonId || null });
const unscanFromCarton = async (shipmentGroupId, weeklyShipId) =>
  axios.post(API_URL + 'carton/unscan', { shipmentGroupId, weeklyShipId });
const resetCartons = async (shipmentGroupId) => axios.post(API_URL + 'carton/reset', { shipmentGroupId });
// แก้ค่าส่ง: correct a ลัง's Thai fee by hand (wallet settles only the difference)
const setCartonFee = async (shipmentGroupId, cartonId, fee) =>
  axios.post(API_URL + 'carton/fee', { shipmentGroupId, cartonId, fee });
// Lalamove: save the rider tracking link + fee → the orders read "ส่งออกแล้ว" (step 12)
const dispatchLalamove = async (shipmentGroupId, link, fee) =>
  axios.post(API_URL + 'lalamove/dispatch', { shipmentGroupId, link, fee });

// Dealer-parcel (D2U) import + QR scan
const dealerImportAir = async (formData) => {
  return await axios.post(API_URL + 'air/dealer-import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000,
  });
};

const dealerScanBox = async (code) => {
  return await axios.post(API_URL + 'air/dealer-scan', { code });
};

// Duplicate dealerBoxNo: the scan returns candidates; this resolves the picked twin.
const dealerScanResolve = async (weeklyShipUuid, shipDate) => {
  return await axios.post(API_URL + 'air/dealer-scan-resolve', { weeklyShipUuid, shipDate });
};

// Dealer "not-arrived": reverse an imported box, list the parked ones, and push a
// parked box into the round it physically arrived in.
const markDealerBoxNotArrived = async (weeklyShipUuid) => {
  return await axios.post(API_URL + 'air/mark-not-arrived', { weeklyShipUuid });
};

const getNotArrivedBoxes = async () => {
  return await axios.get(API_URL + 'air/not-arrived');
};

const dealerPromoteNotArrived = async (weeklyShipUuid, shipDateId) => {
  return await axios.post(API_URL + 'air/dealer-promote-not-arrived', { weeklyShipUuid, shipDateId });
};

// Reconciliation: in-round dealer boxes in this round that were never scanned (possible
// silent misses).
const getDealerUnscannedBoxes = async (shipDateId) => {
  return await axios.get(API_URL + 'air/dealer-unscanned', { params: { shipDateId } });
};

export default {
  addWeeklyShipDate,
  getWeeklyShipDate,
  deleteWeeklyShipDate,
  getUnmatchItemByShipDate,
  getUnmatchBoxUrl,
  getUnmatchUnpackBoxUrl,
  getUnpackUnmatched,
  getUnmatchBoxUrlAir,
  updateOrderTrackingTh,
  addBoxNo,
  getArrivalList,
  arrivalInform,
  addDelayArrival,
  matchWeeklyShipAndOrder,
  cancelWeeklyShipOrderMatch,
  getBoxNoFromProfile,
  awaitUnboxWeeklyShip,
  getBoxNosFromOrderIds,
  uploadAirBarcodes,
  createWeeklyShipAir,
  updateAirWeeklyShip,
  moveAirWeeklyShip,
  deleteAirWeeklyShip,
  getWeeklyShipByShipDateId,
  getWeeklyShipAirDetailByShipDateId,
  getWeeklyShipAirSummaryByShipDateId,
  setWeeklyShipActualCostItems,
  processWeeklyShipGroupByAdmin,
  deActionWeeklyShip,
  getShipmentGroupSummaryByShipDateId,
  exportShipmentGroupToExcel,
  getCompositeJobByShipDate,
  generateComposite,
  downloadCompositeZip,
  previewIshipImport,
  applyIshipImport,
  getArrivalPreview,
  sendArrivalNotifications,
  sendTestArrivalNotification,
  arriveAirWeeklyShip,
  cancelAirWeeklyShip,
  holdAirWeeklyShip,
  getHeldAirItems,
  attachImageToHeldBox,
  promoteHeldAirItem,
  getLabelPendingAirItems,
  markAirLabelPrinted,
  scanOutWeeklyShip,
  listCartons,
  addCarton,
  scanIntoCarton,
  unscanFromCarton,
  resetCartons,
  dispatchLalamove,
  setCartonFee,
  dealerImportAir,
  dealerScanBox,
  dealerScanResolve,
  markDealerBoxNotArrived,
  getNotArrivedBoxes,
  dealerPromoteNotArrived,
  getDealerUnscannedBoxes
};
